import { render, staticRenderFns } from "./confirmation-popup.vue?vue&type=template&id=bae10670&lang=pug"
import script from "./confirmation-popup.vue?vue&type=script&lang=ts"
export * from "./confirmation-popup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports